import React from "react";

function ChiSono() {
    return (
        <section className="py-5 darkerContainer peeks-container">
            <div className="container">
                <div className="row align-items-center">
                    {/* Colonna sinistra */}
                    <div className="col-md-6 text-md-start text-center align-content-hcenter">
                        <div className={'box align-items-center'}>
                            <p className={'boxWrapper'}><span className={'white-color'}>Ascoltare</span> le
                                persone,<br/>
                                accoglierle,<br/>
                                consigliarle con<br/>
                                autentica <span className={'white-color'}>onestà</span></p>
                        </div>
                    </div>
                    <div className="col-md-6 text-md-start text-center">
                        <h2 className="mb-4">Chi sono</h2>
                        <p className="rx-text justify-text">
                            Sono nata a Milano, ma le mie radici sarde hanno sempre rappresentato una bussola interiore che mi accompagna nelle scelte e nel modo di vivere la mia professione. Dopo gli studi al Liceo Classico, ho intrapreso il percorso di Giurisprudenza, spinta dal desiderio di comprendere le regole che governano la società e di poterle trasformare in strumenti di tutela per le persone.

                            La mia prima esperienza in un importante studio legale milanese mi ha permesso di confrontarmi con la complessità del diritto e con le esigenze concrete dei clienti. È stato lì che ho maturato la convinzione di voler proseguire come libera professionista, per poter instaurare un rapporto diretto e autentico con chi si affida a me.

                            Credo che il diritto non sia solo tecnica, ma anche ascolto ed empatia. Per questo mi impegno a comprendere i punti di vista dei miei clienti e a costruire insieme a loro un percorso chiaro e realistico. Non prometto soluzioni miracolose, ma offro dialogo, trasparenza e la capacità di illustrare con precisione sia le opportunità sia i rischi delle diverse strade possibili. Il mio obiettivo è accompagnare le persone nei momenti di incertezza, trasformando la complessità giuridica in un sostegno concreto e affidabile.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ChiSono;